import {Action} from "@ngrx/store";
export const LOAD_ECOMMERCE_PERFORMANCE_NOW: string = '[ecommerce performance now] Load Ecommerce Now Performance';
export const LOAD_ECOMMERCE_PERFORMANCE_NOW_SUCCESS: string = '[ecommerce performance now] Load Ecommerce Performance Now Success';
export const LOAD_ECOMMERCE_PERFORMANCE_NOW_FAIL: string = '[ecommerce performance now] Load Ecommerce Performance Now Fail';

export class LoadEcommercePerformanceNow implements Action {
  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_NOW;

  constructor(public payload: { websiteId: number, datePicker: string, forceCharge?: boolean }) {
  }
}

export class LoadEcommercePerformanceNowSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_NOW_SUCCESS;

  constructor(public payload: {
    dataForToday: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommercePerformanceNowFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_PERFORMANCE_NOW_FAIL;

  constructor(public payload: any) {
  }

}


export type EcommercePerformanceNowAction = LoadEcommercePerformanceNow | LoadEcommercePerformanceNowSuccess | LoadEcommercePerformanceNowFail;
